<template>
  <div class="result-fund">
    <bCardHeader :param="param"></bCardHeader>
    <div class="result-content">
      <img src="@/assets/images/account/icon_submit.png"
           alt="">
      <div class="titile">{{$t('fund.openReview')}}</div>
      <div class="info">{{$t('fund.fivemins')}}</div>
      <div class="btn"
           @click="backHandle">{{$t('fund.return')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      param: {
        title: 'other_account',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'other_account'
          }
        ]
      }
    }
  },
  methods: {
    backHandle () {
      this.$router.push({
        path: '/other-account'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.result-content {
  width: 100%;
  min-height: 660px;
  background: #ffffff;
  box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  img {
    width: 71px;
    height: 71px;
    margin-bottom: 10px;
  }
  .titile {
    font-size: 18px;
    font-weight: 500;
    color: #24282d;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .info {
    font-size: 14px;
    font-weight: 400;
    color: #868e9e;
    line-height: 20px;
    margin-bottom: 45px;
  }
  .btn {
    width: 185px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #20315c;
    font-size: 14px;
    font-weight: 600;
    color: #192b57;
    line-height: 20px;
    text-align: center;
    line-height: 50px;
  }
}
</style>
